// extracted by mini-css-extract-plugin
export default {"TwoDimsListFeature":"wc_a bhh_b","TwoDimsListFeature__item":"wc_b bhh_wb","TwoDimsListFeature__item__text":"wc_c bhh_vr"};